import { Link } from 'react-router-dom';
import { useFavorites } from '../contexts/FavoritesContext';
import { useCart } from '../contexts/CartContext';
import { Heart, ShoppingBag, Trash2 } from 'lucide-react';
import { Star } from 'lucide-react';

export default function FavoritesPage() {
  const { favorites, removeFromFavorites, clearFavorites } = useFavorites();
  const { addToCart } = useCart();

  const handleAddToCart = (product) => {
    addToCart(product, 1);
  };

  if (favorites.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 py-12" data-testid="favorites-page">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="bg-white rounded-xl p-12 text-center">
            <Heart className="w-24 h-24 mx-auto text-gray-300 mb-6" />
            <h2 className="font-manrope font-bold text-2xl mb-4">Favorileriniz Boş</h2>
            <p className="text-gray-600 mb-8">
              Beğendiğiniz ürünleri favorilere ekleyerek daha sonra kolayca ulaşabilirsiniz.
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-trendyol-orange hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
              data-testid="browse-products-button"
            >
              Ürünleri İncele
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 md:py-12" data-testid="favorites-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-manrope font-bold text-2xl md:text-3xl">
            Favorilerim ({favorites.length})
          </h1>
          {favorites.length > 0 && (
            <button
              onClick={clearFavorites}
              className="text-red-500 hover:text-red-600 font-medium text-sm flex items-center gap-2"
              data-testid="clear-favorites-button"
            >
              <Trash2 className="w-4 h-4" />
              Tümünü Temizle
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {favorites.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow relative group"
              data-testid={`favorite-product-${product.id}`}
            >
              <button
                onClick={() => removeFromFavorites(product.id)}
                className="absolute top-2 right-2 z-10 bg-white/90 hover:bg-white p-2 rounded-full shadow-md transition-all"
                data-testid={`remove-favorite-${product.id}`}
              >
                <Heart className="w-5 h-5 fill-red-500 text-red-500" />
              </button>

              <Link to={`/urun/${product.id}`}>
                <div className="aspect-square bg-gray-100 relative overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {product.isNew && (
                    <div className="absolute top-2 left-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded">
                      YENİ
                    </div>
                  )}
                </div>
              </Link>

              <div className="p-3">
                <Link to={`/urun/${product.id}`}>
                  <h3 className="text-sm font-medium mb-2 line-clamp-2 hover:text-trendyol-orange transition-colors">
                    {product.name}
                  </h3>
                </Link>

                <div className="flex items-center gap-1 mb-2">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-3 h-3 ${
                          i < Math.floor(Number(product.rating) || 0)
                            ? 'fill-yellow-400 text-yellow-400'
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">({Number(product.reviews) || 0})</span>
                </div>

                <div className="mb-3">
                  {product.originalPrice && (
                    <p className="text-xs text-gray-400 line-through">
                      {(Number(product.originalPrice) || 0).toFixed(2)} TL
                    </p>
                  )}
                  <p className="font-manrope font-bold text-lg text-trendyol-orange">
                    {(Number(product.price) || 0).toFixed(2)} TL
                  </p>
                </div>

                <button
                  onClick={() => handleAddToCart(product)}
                  className="w-full bg-trendyol-orange hover:bg-orange-600 text-white font-medium py-2 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm"
                  data-testid={`add-to-cart-${product.id}`}
                >
                  <ShoppingBag className="w-4 h-4" />
                  Sepete Ekle
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}